var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.sailboat.co.jp/recruit/","target":"_blank"}},[_c('v-card',[_c('v-img',{attrs:{"src":_vm.BannerImage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }